/**
 * NoSearchResults
 */
import React from 'react';
import { Header } from 'semantic-ui-react';
import { FiSearch } from 'react-icons/fi';

interface Props {
    message: string;
}

export default class NoSearchResults extends React.PureComponent<Props> {
    static defaultProps = {
        message: 'No Search Results'
    };

    render() {
        const { message } = this.props;
        return (
            <Header as="h3" icon textAlign="center">
                <div className="icon">
                    <FiSearch size="40" />
                </div>
                {message}
            </Header>
        );
    }
}
